module.exports = __webpack_public_path__ + "img/page_02.a9f7732b.png";